document.addEventListener('DOMContentLoaded', function () {

  // On page reload add class loaded

  document.body.classList.add("loaded");

  // Number input field dont allow add letters

  document.querySelectorAll('input[type=number]').forEach(inp=>{
    inp.addEventListener('keydown',e=>{
      if(e.key==='e'||e.key==='E'||e.key==='+'||e.key==='-')e.preventDefault()
    })
  })

  // Banner Volume Btn

  const volumeBtn = document.querySelector('.volume');
  volumeBtn.addEventListener('click', function () {
    const volumeOff = this.querySelector('.volume-off');
    const volumeOn = this.querySelector('.volume-on');
    const videoFirst = this.closest('.banner-video').querySelector('.video-desktop video');
    const videoSeconde = this.closest('.banner-video').querySelector('.video-mobile video');
    if(volumeOff.style.display == 'inline-flex'){
      volumeOff.style.display = 'none';
      volumeOn.style.display = 'inline-flex';
      videoFirst.muted = false;
      videoSeconde.muted = false;
    }else{
      volumeOff.style.display = 'inline-flex';
      volumeOn.style.display = 'none';
      videoFirst.muted = true;
      videoSeconde.muted = true;
    }
  });

  // Banner Pause Btn
  
  const pauseBtn = document.querySelector('.pause');
  pauseBtn.addEventListener('click', function () {
    const videoOn = this.querySelector('.video-on');
    const videoOff = this.querySelector('.video-pause');
    const videoFirst = this.closest('.banner-video').querySelector('.video-desktop video');
    const videoSeconde = this.closest('.banner-video').querySelector('.video-mobile video');
    if(videoOn.style.display == 'inline-flex'){
      videoOff.style.display = 'inline-flex';
      videoOn.style.display = 'none';
      videoFirst.pause();
      videoSeconde.pause();
    }else{
      videoOff.style.display = 'none';
      videoOn.style.display = 'inline-flex';
      videoFirst.play();
      videoSeconde.play();
    }
  });

  // Banner Countdown Timer

  const countdownBox = document.querySelector('.countdown-box');
  const endDateAttr = countdownBox.getAttribute('data-countdown');
  const endDate = new Date(endDateAttr).getTime();
  const timerEl = countdownBox.querySelector('.timer');

  function updateCountdown() {
    const now = new Date().getTime();
    const diff = endDate - now;

    if (isNaN(endDate) || diff <= 0) {
      timerEl.textContent = 'Sale Ended!';
      return;
    }

    const d = Math.floor(diff / (1000 * 60 * 60 * 24));
    const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const m = Math.floor((diff / (1000 * 60)) % 60);
    const s = Math.floor((diff / 1000) % 60);

    timerEl.textContent =
      `${d.toString().padStart(2, '0')} : ` +
      `${h.toString().padStart(2, '0')} : ` +
      `${m.toString().padStart(2, '0')} : ` +
      `${s.toString().padStart(2, '0')}`;
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);

});

function checkLines(){
  $(".detail").each(function(){
    let p=$(this).find("p").first(),btn=$(this).find(".read-more");
    if(!p.length||!btn.length)return;
    let lh=parseFloat(p.css("line-height")),lines=p[0].scrollHeight/lh;
    btn.toggle(lines>2);
  });
}

$(document).ready(function(){
  checkLines();$(window).on("resize",checkLines);
  $(".read-more").on("click",function(e){
    e.preventDefault();
    let p=$(this).siblings("p"),ar=window.location.pathname.includes('/ar');
    p.toggleClass("expanded");
    $(this).text(p.hasClass("expanded")?(ar?'قراءة أقل':'Read less'):(ar?'قراءة المزيد':'Read more'))
    .css({position:p.hasClass("expanded")?"unset":"",marginTop:p.hasClass("expanded")?"10px":"0"});
  });
});

// --
// document.addEventListener('DOMContentLoaded', function () {
//   const triggerSection = document.querySelector(
//     'section.cl-block-slider.section-template--20674185003231__cl_blocks_slider_m4dF88'
//   );

//   const targetDiv = document.querySelector(
//     'div#template--20674185003231__hp_banner_HWfB3D'
//   );

//   if (!triggerSection || !targetDiv) return;

//   let animationFrameId = null;
//   let effectStarted = false;
//   let startScrollY = 0;
//   let wasCompletelyInView = false;

//   const updateMargin = () => {
//     if (animationFrameId) {
//       cancelAnimationFrame(animationFrameId);
//     }
    
//     animationFrameId = requestAnimationFrame(() => {
//       const triggerRect = triggerSection.getBoundingClientRect();
//       const windowHeight = window.innerHeight;
//       const currentScrollY = window.pageYOffset || document.documentElement.scrollTop;
      
//       const isCompletelyInView = triggerRect.top >= 0 && triggerRect.bottom <= windowHeight;
//       const isPartiallyInView = triggerRect.top <= windowHeight && triggerRect.bottom >= 0;

//       // Reset startScrollY when entering completely in view from any direction
//       if (isCompletelyInView && !wasCompletelyInView) {
//         effectStarted = true;
//         startScrollY = currentScrollY;
//         targetDiv.style.transition = 'none';
//         wasCompletelyInView = true;
//       } else if (!isCompletelyInView) {
//         wasCompletelyInView = false;
//       }

//       if (isCompletelyInView && effectStarted) {
//         // Calculate margin based on scroll from when section became completely visible
//         const scrollDiff = currentScrollY - startScrollY;
//         const sectionTopOffset = triggerRect.top;
//         const marginValue = Math.max(0, Math.min(scrollDiff + sectionTopOffset, windowHeight));
        
//         targetDiv.style.transition = 'margin-top 0.05s linear';
//         targetDiv.style.marginTop = `-${marginValue}px`;
        
//       } else if (isPartiallyInView && triggerRect.top >= 0 && triggerRect.bottom > windowHeight) {
//         // Section entering from bottom
//         targetDiv.style.transition = 'margin-top 0.3s ease-out';
//         targetDiv.style.marginTop = '0px';
//         effectStarted = false;
        
//       } else if (isPartiallyInView && triggerRect.top < 0 && effectStarted) {
//         // Section scrolling past top
//         const scrollPast = Math.abs(triggerRect.top);
//         const remainingHeight = Math.max(0, triggerRect.bottom);
//         const marginValue = Math.min(windowHeight - remainingHeight, windowHeight);
        
//         targetDiv.style.transition = 'margin-top 0.05s linear';
//         targetDiv.style.marginTop = `-${marginValue}px`;
        
//       } else if (!isPartiallyInView) {
//         if (triggerRect.bottom < 0) {
//           // Completely scrolled past
//           targetDiv.style.transition = 'margin-top 0.3s ease-out';
//           targetDiv.style.marginTop = `-${windowHeight}px`;
//         } else {
//           // Before section
//           targetDiv.style.transition = 'margin-top 0.3s ease-out';
//           targetDiv.style.marginTop = '0px';
//           effectStarted = false;
//         }
//       }
//     });
//   };

//   window.addEventListener('scroll', updateMargin, { passive: true });
//   window.addEventListener('resize', updateMargin, { passive: true });
  
//   updateMargin();
// });